import { ForwardedRef, forwardRef } from "react";
import {
  FreeTrialInfo,
  ResellerUserInfo,
  SIGNUP_UPDATE_TYPE,
  SignupUserInfo,
} from "api/interfaces/authInterface.interface";
import Input from "components/atoms/input/Input";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";

interface Props {
  validateInputMsg: ValidateMsg;
  onChangeUserInfo: (type: SIGNUP_UPDATE_TYPE, data: string | boolean) => void;
  userInfo: SignupUserInfo | ResellerUserInfo | FreeTrialInfo;
  label: string;
  tabIndex: number;
  fieldKey: string;
  type: SIGNUP_UPDATE_TYPE;
  maxLength?: number;
}

export const vowel = ["a", "e", "i", "o", "u"];

function InputItem(props: Props, ref?: ForwardedRef<HTMLInputElement>) {
  const {
    validateInputMsg,
    onChangeUserInfo,
    userInfo,
    label,
    tabIndex,
    fieldKey,
    type,
    maxLength,
  } = props;
  const firstLetter = ((label || "").charAt(0) || "").toLowerCase();
  return (
    <ModalInput
      label={label}
      noBold
      essential
      isValidated={!!validateInputMsg[fieldKey]}
      validatedWord={validateInputMsg[fieldKey]}
    >
      <Input
        id={`dw_signup_input_${fieldKey}`}
        ref={ref}
        type="text"
        className="input-field"
        placeholder={`Please enter ${
          vowel.includes(firstLetter) ? "an" : "a"
        } ${label.toLowerCase()}`}
        autoComplete="new-password"
        value={
          userInfo[
            fieldKey as keyof (
              | SignupUserInfo
              | ResellerUserInfo
              | FreeTrialInfo
            )
          ] as string
        }
        onChange={(e) => onChangeUserInfo(type, e.target.value)}
        isValidated={!!validateInputMsg[fieldKey]}
        tabIndex={tabIndex}
        maxLength={maxLength}
        data-testid="auth-signup-common-input-change-user-info"
      />
    </ModalInput>
  );
}

export default forwardRef(InputItem);
